import { defineMessages } from 'react-intl';
import * as Actions from '../../../create-label-content/create-label-content.actions';

const messages = defineMessages({
  createLabel: {
    defaultMessage: 'Schedule Pickup',
    id: 'Q/RKXZ',
    description: 'CSW primary button label - Schedule Pickup',
  },
});

export const createLabel = {
  id: 'createLabel',
  translation: messages.createLabel,

  getActionFromFulfillmentPlanId: (fulfillmentPlanId, labelMetadata) => {
    return Actions.createLabel({
      fulfillmentPlanId,
      doNotPrint: true,
      labelMetadata,
    });
  },
};
